<template>
  <div class="modal fade" id="add-sales-new">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper p-0 m-0">
          <div class="content p-0">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Ajouter un Devis</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Client</label>
                        <div class="col-lg-12 col-sm-10 col-10">
                          <vue-select :options="clientData" v-model="form.nom_client" id="choosefive"
                            placeholder="Choose" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Mode du Paiement</label>
                        <vue-select :options="PaiementMethods" v-model="form.mode_paiement" id="choosename"
                          placeholder="choose" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Conditions de règlement</label>
                        <vue-select :options="Conditions" v-model="form.conditions_paiement" id="choosensamess"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Délai de livraison </label>
                        <vue-select :options="delaisOptions" id="choosenamessa" placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Statut du devis</label>
                        <vue-select v-model="form.statut1" :options="Completed1" id="progressssdee"
                          placeholder="Choose" />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Type</label>
                        <div class="row">
                          <div class="col-lg-12 col-sm-10 col-10">
                            <vue-select :options="producttsType" id="dazdadzdffghddh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="selectedType"
                              @input="handleType" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Produit / Service</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select :options="itemsList" id="dazdadzdffghh"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="form.selectedProduct" />
                          </div>
                          <div class="col-lg-1 col-sm-2 col-2 ps-0">
                            <div class="add-icon">
                              <a href="javascript:void(0);" class="choose-add"
                                v-on:click="addProduct(selectedProducts, form)">
                                <vue-feather type="plus-circle" class="plus"></vue-feather>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isCommandeLinesLoading" class="text-center my-4">
                    <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                  </div>
                  <div class="table-responsive no-pagination" v-show="!isCommandeLinesLoading">
                    <table class="table datanew">
                      <thead>
                        <tr>
                          <th>Produit / Service</th>
                          <th>Type</th>
                          <th>Prix Unitaire</th>
                          <th>Quantité</th>
                          <th>Réduc (%)</th>
                          <th>Prix HT</th>
                          <th>TVA</th>
                          <th>Prix TTC</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in selectedProducts" :key="index">
                          <td v-if="product.item_id !== null">
                            <div class="productimgname">
                              <a href="javascript:void(0);">{{ product.nom }}</a>
                            </div>
                          </td>
                          <td v-else>
                            <div class="productimgname align-items-center">
                              <div class="input-blocks">
                                <div class="input-group select-code">
                                  <input type="text" placeholder="0" v-model="selectedProducts[index].nom" />
                                </div>
                              </div>
                            </div>
                          </td>
                          <td v-if="product.item_id !== null">{{ product.item_type }}</td>
                          <td v-else>
                            <vue-select :options="producttsType" v-model="selectedProducts[index].item_type" />

                          </td>
                          <td v-if="product.item_id !== null">{{ product.prix_unitaire }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" class="form-control" placeholder="0"
                                  @input="changePrice(index, selectedProducts, form)"
                                  v-model="selectedProducts[index].prix_unitaire" />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="product-quantity">
                              <span class="quantity-btn" v-on:click="increaseQuantity(index, selectedProducts, form)">
                                +<vue-feather type="plus-circle" class="plus-circle"></vue-feather>
                              </span>
                              <input type="text" class="quntity-input" v-model="product.quantite" disabled />
                              <span class="quantity-btn" v-on:click="decreaseQuantity(index, selectedProducts, form)">
                                <vue-feather type="minus-circle" class="search"></vue-feather>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" max="100" step="0.01" class="form-control" placeholder="0"
                                  v-model.number="selectedProducts[index].reduc"
                                  @input="changePrice(index, selectedProducts, form)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_HT.toFixed ? product.montant_HT.toFixed(2) : product.montant_HT }}</td>
                          <td v-if="product.item_id !== null">{{ product.tax }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" step="0.01" class="form-control"
                                  v-model.number="selectedProducts[index].tax"
                                  @input="changePrice(index, selectedProducts, form)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_TTC }}</td>
                          <td>
                            <a class="confirm-text p-2"
                              @click="deleteProduct(index, selectedProducts, form, deletedProducts)"
                              href="javascript:void(0);">
                              <vue-feather type="trash-2" class="trash-2"></vue-feather>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 ms-auto">
                      <div class="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Totale HT</h4>
                            <h5>{{ Number(form.montant_HT).toFixed(2) }}</h5>
                          </li>
                          <li>
                            <h4>TVA</h4>
                            <h5>{{ Number(form.montant_TTC - form.montant_HT).toFixed(2) }}</h5>
                          </li>
                          <li>
                            <h4>Totale TTC</h4>
                            <h5>{{ Number(form.montant_TTC).toFixed(2) }}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="input-blocks">
                        <label>Notes</label>
                        <textarea class="form-control" v-model="form.notes"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-end">
                      <button type="button" class="btn btn-cancel add-cancel me-3"
                        data-bs-dismiss="modal">Annuler</button>
                      <button type="submit" class="btn btn-submit add-sale">Ajouter</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /add popup -->

  <!-- edit popup -->
  <div class="modal fade" id="edit-sales-new" ref="editModalEl">
    <div class="modal-dialog edit-sales-modal">
      <div class="modal-content">
        <div class="page-wrapper p-0 m-0">
          <div class="content p-0">
            <div class="page-header p-4 mb-0">
              <div class="add-item new-sale-items d-flex">
                <div class="page-title">
                  <h4>Modifier le Devis</h4>
                </div>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm1">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Client</label>
                        <div class="row">
                          <div class="col-lg-12 col-sm-12 col-12">
                            <vue-select :options="clientData" v-model="form1.nom_client" id="choosefivei"
                              placeholder="Choose" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Mode du Paiement</label>
                        <vue-select :options="PaiementMethods" v-model="form1.mode_paiement" id="choosenamejj"
                          placeholder="choose" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Conditions de règlement</label>
                        <vue-select :options="Conditions" v-model="form1.conditions_paiement" id="choosensamessii"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Délai de livraison </label>
                        <vue-select :options="delaisOptions" v-model="form1.delaiLivraision" id="choosenamessaff"
                          placeholder="choose" />
                      </div>
                    </div>
                    <div class="col-lg-4 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Statut du devis</label>
                        <vue-select v-model="form1.statut1" :options="Completed1" id="progressssdeeplpl"
                          placeholder="Choose" />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Type</label>
                        <div class="col-lg-12 col-sm-12 col-12">
                          <vue-select :options="producttsType" id="dazdadzdffghddhtyt"
                            placeholder="Ajouter un nouveau Produit / Service" v-model="selectedType"
                            @input="handleType" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-6 col-12">
                      <div class="input-blocks">
                        <label>Nom du Produit / Service</label>
                        <div class="row">
                          <div class="col-lg-11 col-sm-10 col-10">
                            <vue-select :options="itemsList" id="dazdadzdffghddhaa"
                              placeholder="Ajouter un nouveau Produit / Service" v-model="form1.selectedProduct" />
                          </div>
                          <div class="col-lg-1 col-sm-2 col-2 ps-0">
                            <div class="add-icon">
                              <a href="javascript:void(0);" class="choose-add"
                                v-on:click="addProduct(selectedProducts1, form1)">
                                <vue-feather type="plus-circle" class="plus"></vue-feather>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isCommandeLinesLoading" class="text-center my-4">
                    <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
                  </div>
                  <div class="table-responsive no-pagination" v-show="!isCommandeLinesLoading">
                    <table class="table datanew">
                      <thead>
                        <tr>
                          <th>Produit / Service</th>
                          <th>Type</th>
                          <th>Prix Unitaire</th>
                          <th>Quantité</th>
                          <th>Réduc (%)</th>
                          <th>Prix HT</th>
                          <th>TVA</th>
                          <th>Prix TTC</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(product, index) in selectedProducts1" :key="index">
                          <td v-if="product.item_id !== null">
                            <div class="productimgname">
                              <a href="javascript:void(0);">{{ product.nom }}</a>
                            </div>
                          </td>
                          <td v-else>
                            <div class="productimgname align-items-center">
                              <div class="input-blocks">
                                <div class="input-group select-code">
                                  <input type="text" placeholder="0" v-model="selectedProducts1[index].nom" />
                                </div>
                              </div>
                            </div>
                          </td>
                          <td v-if="product.item_id !== null">{{ product.item_type }}</td>
                          <td v-else>
                            <vue-select :options="producttsType" v-model="selectedProducts1[index].item_type" />
                          </td>
                          <td v-if="product.item_id !== null">{{ product.prix_unitaire }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" class="form-control" placeholder="0"
                                  @input="changePrice(index, selectedProducts1, form1)"
                                  v-model="selectedProducts1[index].prix_unitaire" />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="product-quantity">
                              <span class="quantity-btn" v-on:click="increaseQuantity(index, selectedProducts1, form1)">
                                +<vue-feather type="plus-circle" class="plus-circle"></vue-feather>
                              </span>
                              <input type="text" class="quntity-input" v-model="product.quantite" disabled />
                              <span class="quantity-btn" v-on:click="decreaseQuantity(index, selectedProducts1, form1)">
                                <vue-feather type="minus-circle" class="search"></vue-feather>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" max="100" step="0.01" class="form-control" placeholder="0"
                                  v-model.number="selectedProducts1[index].reduc"
                                  @input="changePrice(index, selectedProducts1, form1)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_HT.toFixed ? product.montant_HT.toFixed(2) : product.montant_HT }}</td>
                          <td v-if="product.item_id !== null">{{ product.tax }}</td>
                          <td v-else>
                            <div class="input-blocks">
                              <div class="input-group">
                                <input type="number" min="0" step="0.01" class="form-control"
                                  v-model.number="selectedProducts1[index].tax"
                                  @input="changePrice(index, selectedProducts1, form1)" />
                              </div>
                            </div>
                          </td>
                          <td>{{ product.montant_TTC }}</td>
                          <td>
                            <a class="confirm-text p-2"
                              @click="deleteProduct(index, selectedProducts1, form1, deletedProducts1)"
                              href="javascript:void(0);">
                              <vue-feather type="trash-2" class="trash-2"></vue-feather>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 ms-auto">
                      <div class="total-order w-100 max-widthauto m-auto mb-4">
                        <ul>
                          <li>
                            <h4>Totale HT</h4>
                            <h5>{{ form1.montant_HT ? Number(form1.montant_HT).toFixed(2) : 0 }}</h5>
                          </li>
                          <li>
                            <h4>TVA</h4>
                            <h5>{{ form1.montant_HT ? Number(form1.montant_TTC - form1.montant_HT).toFixed(2) : 0 }}
                            </h5>
                          </li>
                          <li>
                            <h4>Totale TTC</h4>
                            <h5>{{ form1.montant_TTC ? Number(form1.montant_TTC).toFixed(2) : 0 }}</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="input-blocks">
                        <label>Notes</label>
                        <textarea class="form-control" v-model="form1.notes"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-end">
                      <button type="button" class="btn btn-cancel add-cancel me-3"
                        data-bs-dismiss="modal">Annuler</button>
                      <button type="submit" class="btn btn-submit add-sale">Modifier</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- details popup -->
  <div class="modal fade" id="sales-details-new">
    <div class="modal-dialog sales-details-modal">
      <div class="modal-content">
        <div class="page-wrapper details-blk">
          <div class="content p-0">
            <div class="page-header p-4 mb-0">
              <div class="add-item d-flex">
                <div class="page-title modal-datail">
                  <h4>Sales Detail : SL0101</h4>
                </div>
                <div class="page-btn">
                  <a href="javascript:void(0);" class="btn btn-added"><vue-feather type="plus-circle"
                      class="me-2"></vue-feather>
                    Add New Sales</a>
                </div>
              </div>
              <ul class="table-top-head">
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><vue-feather type="edit"
                      class="action-edit sales-action"></vue-feather></a>
                </li>
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="@/assets/img/icons/pdf.svg"
                      alt="img" /></a>
                </li>
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img
                      src="@/assets/img/icons/excel.svg" alt="img" /></a>
                </li>
                <li>
                  <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><vue-feather type="printer"
                      class="feather-rotate-ccw"></vue-feather></a>
                </li>
              </ul>
            </div>

            <div class="card">
              <div class="card-body">
                <form @submit.prevent="submitForm">
                  <div class="invoice-box table-height" style="
                      max-width: 1600px;
                      width: 100%;
                      overflow: auto;
                      padding: 0;
                      font-size: 14px;
                      line-height: 24px;
                      color: #555;
                    ">
                    <div class="sales-details-items d-flex">
                      <div class="details-item">
                        <h6>Customer Info</h6>
                        <p>
                          walk-in-customer<br />
                          walk-in-customer@example.com<br />
                          123456780<br />
                          N45 , Dhaka
                        </p>
                      </div>
                      <div class="details-item">
                        <h6>Company Info</h6>
                        <p>
                          DGT<br />
                          admin@example.com<br />
                          6315996770<br />
                          3618 Abia Martin Drive
                        </p>
                      </div>
                      <div class="details-item">
                        <h6>Invoice Info</h6>
                        <p>
                          Reference<br />
                          Payment Status<br />
                          Status
                        </p>
                      </div>
                      <div class="details-item">
                        <h5>
                          <span>SL0101</span>Paid<br />
                          Completed
                        </h5>
                      </div>
                    </div>
                    <h5 class="order-text">Order Summary</h5>
                    <div class="table-responsive no-pagination">
                      <table class="table datanew">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Purchase Price($)</th>
                            <th>Discount($)</th>
                            <th>Tax(%)</th>
                            <th>Tax Amount($)</th>
                            <th>Unit Cost($)</th>
                            <th>Total Cost(%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div class="productimgname">
                                <a href="javascript:void(0);" class="product-img stock-img">
                                  <img src="@/assets/img/products/product1.jpg" alt="product" />
                                </a>
                                <a href="javascript:void(0);">Nike Jordan</a>
                              </div>
                            </td>
                            <td>
                              <div class="product-quantity">
                                <span class="quantity-btn">+<vue-feather type="plus-circle"
                                    class="plus-circle"></vue-feather></span>
                                <input type="text" class="quntity-input" value="2" />
                                <span class="quantity-btn"><vue-feather type="minus-circle"
                                    class="search"></vue-feather></span>
                              </div>
                            </td>
                            <td>2000</td>
                            <td>500</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>1500</td>
                          </tr>
                          <tr>
                            <td>
                              <div class="productimgname">
                                <a href="javascript:void(0);" class="product-img stock-img">
                                  <img src="@/assets/img/products/product1.jpg" alt="product" />
                                </a>
                                <a href="javascript:void(0);">Apple Series 5 Watch</a>
                              </div>
                            </td>
                            <td>
                              <div class="product-quantity">
                                <span class="quantity-btn">+<vue-feather type="plus-circle"
                                    class="plus-circle"></vue-feather></span>
                                <input type="text" class="quntity-input" value="2" />
                                <span class="quantity-btn"><vue-feather type="minus-circle"
                                    class="search"></vue-feather></span>
                              </div>
                            </td>
                            <td>3000</td>
                            <td>400</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>1700</td>
                          </tr>
                          <tr>
                            <td>
                              <div class="productimgname">
                                <a href="javascript:void(0);" class="product-img stock-img">
                                  <img src="@/assets/img/products/product1.jpg" alt="product" />
                                </a>
                                <a href="javascript:void(0);">Lobar Handy</a>
                              </div>
                            </td>
                            <td>
                              <div class="product-quantity">
                                <span class="quantity-btn">+<vue-feather type="plus-circle"
                                    class="plus-circle"></vue-feather></span>
                                <input type="text" class="quntity-input" value="2" />
                                <span class="quantity-btn"><vue-feather type="minus-circle"
                                    class="search"></vue-feather></span>
                              </div>
                            </td>
                            <td>2500</td>
                            <td>500</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>0.00</td>
                            <td>2000</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="row">
                    <div class="row">
                      <div class="col-lg-6 ms-auto">
                        <div class="total-order w-100 max-widthauto m-auto mb-4">
                          <ul>
                            <li>
                              <h4>Order Tax</h4>
                              <h5>$ 0.00</h5>
                            </li>
                            <li>
                              <h4>Discount</h4>
                              <h5>$ 0.00</h5>
                            </li>
                            <li>
                              <h4>Grand Total</h4>
                              <h5>$ 5200.00</h5>
                            </li>
                            <li>
                              <h4>Paid</h4>
                              <h5>$ 5200.00</h5>
                            </li>
                            <li>
                              <h4>Due</h4>
                              <h5>$ 0.00</h5>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /details popup -->



  <!-- show payment Modal -->
  <div class="modal fade" id="showpayment" tabindex="-1" aria-labelledby="showpayment" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered stock-adjust-modal">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4>Show Payments</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="modal-body-table total-orders">
                    <div class="table-responsive">
                      <table class="table datanew">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Reference</th>
                            <th>Amount</th>
                            <th>Paid By</th>
                            <th class="no-sort">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>19 Jan 2023</td>
                            <td>INV/SL0101</td>
                            <td>$1500</td>
                            <td>Cash</td>
                            <td class="action-table-data">
                              <div class="edit-delete-action">
                                <a class="me-3 p-2" href="javascript:void(0);">
                                  <vue-feather type="printer" class="printer"></vue-feather>
                                </a>
                                <a class="me-3 p-2" href="javascript:void(0);" data-bs-toggle="modal"
                                  data-bs-target="#editpayment">
                                  <vue-feather type="edit" class="feather-edit"></vue-feather>
                                </a>
                                <a class="confirm-text p-2" href="javascript:void(0);" @click="showConfirmation">
                                  <vue-feather type="trash-2" class="feather-trash-2"></vue-feather>
                                </a>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- show payment Modal -->

  <!-- Create payment Modal -->
  <div class="modal fade" id="createpayment" tabindex="-1" aria-labelledby="createpayment" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 custom-modal-header">
          <div class="page-title">
            <h4>Create Payments</h4>
          </div>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-blocks">
                  <label> Date</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="calendar" class="info-img"></vue-feather>
                    <input type="text" class="datetimepicker" placeholder="Choose Date" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Reference</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Received Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Paying Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Payment type</label>
                  <vue-select :options="OnlineOne" id="online01" placeholder="Choose" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-blocks">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                  <p>Maximum 60 Characters</p>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="modal-footer-btn">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Create payment Modal -->

  <!-- edit payment Modal -->
  <div class="modal fade" id="editpayment" tabindex="-1" aria-labelledby="editpayment" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 custom-modal-header">
          <div class="page-title">
            <h4>Edit Payments</h4>
          </div>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body custom-modal-body">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-blocks">
                  <label>19 Jan 2023</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="calendar" class="info-img"></vue-feather>
                    <input type="text" class="datetimepicker form-control" placeholder="Select Date" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Reference</label>
                  <input type="text" value="INV/SL0101" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Received Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" value="1500" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Paying Amount</label>
                  <div class="input-groupicon calender-input">
                    <vue-feather type="dollar-sign" class="info-img"></vue-feather>
                    <input type="text" value="1500" />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="input-blocks">
                  <label>Payment type</label>
                  <vue-select :options="Online" id="cash" placeholder="Cash" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="input-blocks summer-description-box transfer">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                </div>
                <p>Maximum 60 Characters</p>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="modal-footer-btn mb-3 me-3">
                <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-submit">
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- edit payment Modal -->
</template>

<script>
import { getClientsData } from "@/services/clientsService";
import { getProductsDataInStock, getServicesData } from "@/services/productsService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import { getLignesCommandeDataByCommandeId } from "@/services/devisService";
import {
  createCommand,
  createCommandLine,
  createDevis,
  updateCommand,
  updateCommandLine,
  updateDevis,
  deleteCommandLine,
} from "@/services/devisService";

import Swal from "sweetalert2";
import { ref } from "vue";
import { toast } from "vue3-toastify";
const currentDate = ref(new Date());
const clientData = [];
const clientIds = [];
const productsData = [];
const productsIds = [];
const selectedProducts = [];
const selectedProducts1 = [];
const deletedProducts = [];
const deletedProducts1 = [];
const insertedProducts = [];
const itemsList = [];

const commandeLinesCache = new Map();
const COMMAND_LINES_CACHE_TTL_MS = 5000;
let activeCommandeLinesFetch = null;
let activeCommandeLinesId = null;

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  formatSQLDate(value) {
    try {
      const d = value instanceof Date ? value : new Date(value);
      if (isNaN(d)) return null;
      return d.toISOString().slice(0, 19).replace("T", " ");
    } catch (_) {
      return null;
    }
  },
  data() {
    return {
      form: {
        nom_client: "",
        selectedProduct: "",
        montant_HT: 0,
        montant_TTC: 0,
        date_creation: currentDate,
        statut: "TERMINEE",
        mode_paiement: "",
        conditions_paiement: "",
        date_livraison: currentDate,
        client_id: null,
        montant_total: 0,
        montant_taxe: 0,
        numero_commande: "",
        notes: "",
        cree_par: null,
        societe_id: null,
        numero_devis: "",
        statut1: "",
      },
      form1: {
        nom_client: "",
        selectedProduct: "",
        montant_HT: 0,
        montant_TTC: 0,
        date_creation: currentDate,
        statut: "TERMINEE",
        mode_paiement: "",
        conditions_paiement: "",
        date_livraison: currentDate,
        client_id: null,
        montant_total: 0,
        montant_taxe: 0,
        numero_commande: "",
        notes: "",
        cree_par: 2,
        societe_id: 1,
        numero_devis: "",
        statut1: "",
        delaiLivraision: "",
        commande_id: null,
      },
      Choose: ["Choose", "Customer Name"],
      Choosename: ["Choose", "Supplier Name"],
      Completed: ["ANNULEE", "TERMINEE", "EN_ATTENTE", "EN_COURS", "EXPEDIEE"],
      Completed1: ["BROUILLON", "VALIDÉ", "ANNULÉ"],
      Types: ["PRODUIT", "SERVICE"],
      Thomas: ["Thomas", "Name"],
      Shoes: ["Dazzle Shoes", "Supplier Name"],
      Online: ["Choose", "Online", "Cash"],
      OnlineOne: ["Choose", "Online", "Cash"],
      PaiementMethods: [
        "Carte Bancaire",
        "Chèque",
        "Espèce",
        "Ordre de Prélèvement",
        "Virement Bancaire",
      ],
      Conditions: [
        "A réception",
        "10 jours",
        "10 jours fin de mois",
        "14 jours",
        "14 jours fin de mois",
        "30 jours",
        "30 jours fin de mois",
        "60 jours",
        "60 jours fin de mois",
        "A commande",
        "A Livraison",
        "50/50",
      ],
      delaisOptions: [
        "Immédiate (0 jour)",
        "1 jour",
        "2 jours",
        "3 jours",
        "4 jours",
        "5 jours",
        "1 semaine (7 jours)",
        "2 semaines (14 jours)",
        "3 semaines (21 jours)",
        "4 semaines (28 jours)",
        "5 semaines (35 jours)",
        "6 semaines (42 jours)",
        "8 semaines (56 jours)",
        "10 semaines (70 jours)",
        "12 semaines (84 jours)",
        "14 semaines (98 jours)",
        "16 semaines (112 jours)",
      ],
      producttsType: ["PRODUIT", "SERVICE"],
      selectedTypeAdd: "PRODUIT",
      selectedTypeEdit: "PRODUIT",

      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      clientData,
      clientIds,
      productsData,
      productsIds,
      selectedProducts,
      selectedProducts1,
      deletedProducts,
      deletedProducts1,
      insertedProducts,
      itemsList,
      isCommandeLinesLoading: false,
    };
  },
  methods: {
    async loadCommandeLines(commandeId) {
      if (!commandeId) {
        this.selectedProducts1 = [];
        this.deletedProducts1 = [];
        this.isCommandeLinesLoading = false;
        return [];
      }

      const now = Date.now();
      const cached = commandeLinesCache.get(commandeId);
      if (cached && now - cached.timestamp < COMMAND_LINES_CACHE_TTL_MS) {
        this.applyCommandeLines(cached.data);
        this.isCommandeLinesLoading = false;
        return cached.data;
      }

      this.isCommandeLinesLoading = true;

      if (activeCommandeLinesFetch && activeCommandeLinesId === commandeId) {
        try {
          const data = await activeCommandeLinesFetch;
          this.applyCommandeLines(data);
          return data;
        } catch (_) {
          return [];
        } finally {
          this.isCommandeLinesLoading = false;
        }
      }

      const fetchPromise = (async () => {
        try {
          const data = await getLignesCommandeDataByCommandeId(commandeId);
          commandeLinesCache.set(commandeId, {
            data,
            timestamp: Date.now(),
          });
          return data;
        } catch (error) {
          const status = error?.response?.status;
          if (status === 429) {
            toast.error("Trop de requêtes reçues. Merci de patienter quelques secondes.");
          } else {
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "Impossible de récupérer les lignes de commande.";
            toast.error(message);
          }
          throw error;
        }
      })();

      activeCommandeLinesId = commandeId;
      activeCommandeLinesFetch = fetchPromise;

      try {
        const data = await fetchPromise;
        this.applyCommandeLines(data);
        return data;
      } finally {
        activeCommandeLinesFetch = null;
        activeCommandeLinesId = null;
        this.isCommandeLinesLoading = false;
      }
    },
    applyCommandeLines(data) {
      const mapped = Array.isArray(data)
        ? data.map((m) => {
          const montantHT = parseFloat(m.montant_HT) || 0;
          const montantTTC = parseFloat(m.montant_TTC) || 0;
          const rate = montantHT > 0 ? ((montantTTC / montantHT - 1) * 100) : 0;

          return {
            id: m.id,
            quantite: m.quantite,
            prix_unitaire: m.prix_unitaire,
            reduc: Number(m.reduction ?? 0),
            montant_HT: montantHT,
            montant_TTC: montantTTC,
            item_type: m.item_type, // keep ENUM value,
            item_type1: m.item_type,
            item_id: m.item_id,
            nom: m.item_data ? m.item_data.nom : m.nom_libre,
            tax: Number(rate.toFixed(2)) || 0,
            societe_id: m.societe_id,
          };
        })
        : [];

      this.selectedProducts1 = mapped;
      this.deletedProducts1 = [];
      if (this.form1) {
        this.recalculateTotals(this.selectedProducts1, this.form1);
      }
    },
    changePrice(index, list, form) {
      this.recalculateLine(list[index]);
      this.recalculateTotals(list, form);
    },
    increaseQuantity(index, list, form) {
      if (list[index].quantite !== undefined) {
        list[index].quantite++;
        this.recalculateLine(list[index]);
        this.recalculateTotals(list, form);
      }
    },
    decreaseQuantity(index, list, form) {
      if (list[index].quantite !== undefined && list[index].quantite > 1) {
        list[index].quantite--;
        this.recalculateLine(list[index]);
        this.recalculateTotals(list, form);
      }
    },
    normalizeTax(value) {
      if (value === null || value === undefined) return 0;
      const n = Number(String(value).replace(',', '.'));
      return isNaN(n) ? 0 : n;
    },
    normalizePercent(value) {
      if (value === null || value === undefined) return 0;
      const n = Number(String(value).replace(',', '.'));
      if (isNaN(n)) return 0;
      if (n < 0) return 0;
      if (n > 100) return 100;
      return n;
    },
    recalculateLine(line) {
      const qty = Number(line.quantite) || 0;
      const unit = Number(line.prix_unitaire) || 0;
      const rate = this.normalizeTax(line.tax);
      const reduc = this.normalizePercent(line.reduc);
      const netUnit = unit * (1 - reduc / 100);
      line.montant_HT = netUnit * qty;
      line.montant_TTC = line.montant_HT * (rate / 100) + line.montant_HT;
    },
    recalculateTotals(list, form) {
      form.montant_HT = 0;
      form.montant_TTC = 0;
      list.forEach((product) => {
        form.montant_HT += Number(product.montant_HT) || 0;
        form.montant_TTC += Number(product.montant_TTC) || 0;
      });
    },
    deleteProduct(index, list, form, deleted) {
      const removed = list.splice(index, 1);
      if (removed.length) deleted.push(removed[0]);
      this.recalculateTotals(list, form);
    },
    showConfirmation() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    async getClientsData() {
      this.clientData = [];
      this.clientIds = [];
      if (localStorage.getItem("clients") != null) {
        const data = JSON.parse(localStorage.getItem("clients"));
        data.map((m) => {
          this.clientData.push(m.nom + " " + m.prenom);
          this.clientIds.push(m.id);
        });
      } else {
        try {
          const data = await getClientsData();
          data.map((m) => {
            this.clientData.push(m.nom + " " + m.prenom);
            this.clientIds.push(m.id);
          });
        } catch (error) {
          console.error(error);
          const msg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Une erreur est survenue";
          toast.error(msg);
        }
      }
    },
    getClientID(option) {
      let index = this.clientData.indexOf(option);
      if (index != -1) {
        return this.clientIds[index];
      }
      return index;
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    async getProductsData() {
      this.productsData = [];
      this.productsIds = [];
      if (localStorage.getItem("products") != null) {
        const data = JSON.parse(localStorage.getItem("products"));
        data.map((m) => {
          m.item_type = "product";
          this.productsData.push(m.nom);
          this.productsIds.push(m);
        });
      } else {
        try {
          const data = await getProductsDataInStock();
          data.map((m) => {
            m.item_type = "product";
            this.productsData.push(m.nom);
            this.productsIds.push(m);
          });
        } catch (error) {
          console.error(error);
          const msg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Une erreur est survenue";
          toast.error(msg);
        }
      }

      if (localStorage.getItem("services") != null) {
        const data = JSON.parse(localStorage.getItem("services"));
        data.map((m) => {
          m.item_type = "service";
          this.productsData.push(m.nom);
          this.productsIds.push(m);
        });
      } else {
        try {
          const data = await getServicesData();
          data.map((m) => {
            m.item_type = "service";
            this.productsData.push(m.nom);
            this.productsIds.push(m);
          });
        } catch (error) {
          console.error(error);
          const msg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Une erreur est survenue";
          toast.error(msg);
        }
      }
      this.itemsList = this.productsIds
        .filter((product) => product.item_type === "product")
        .map((product) => product.nom);
    },
    getProductsID(option) {
      let index = this.productsData.indexOf(option);
      if (index != -1) {
        return this.productsIds[index];
      }
      return {};
    },
    getProductName(option) {
      let product = productsIds.find((m) => m.id === option);
      let index = this.productsIds.indexOf(product);
      if (index != -1) {
        return this.productsData[index];
      }
      return {};
    },
    addProduct(list, form) {
      const item = this.getProductsID(form.selectedProduct);
      const currentType =
        form === this.form ? this.selectedTypeAdd : this.selectedTypeEdit;

      // MANUAL PRODUCT
      if (!item || !item.id) {
        list.push({
          id: null,
          quantite: 1,
          prix_unitaire: 0,
          reduc: 0,
          montant_HT: 0,
          montant_TTC: 0,
          item_type: currentType,
          item_type1: currentType,
          item_id: null,
          nom: "",
          tax: 0,
          societe_id: this.form.societe_id,
        });
      }
      // DB PRODUCT / SERVICE
      else {
        const quantite = 1;
        const rate = this.normalizeTax(
          item.item_type === "product" ? item.taux_tva : item.taux_taxe
        );
        const montant_HT = item.prix_vente * quantite;
        const montant_TTC = montant_HT + montant_HT * (rate / 100);

        list.push({
          id: null,
          quantite,
          prix_unitaire: item.prix_vente,
          reduc: 0,
          montant_HT,
          montant_TTC,
          item_type: item.item_type === "product" ? "PRODUIT" : "SERVICE",
          item_type1: item.item_type === "product" ? "PRODUIT" : "SERVICE",
          item_id: item.id,
          nom: item.nom,
          tax: rate,
          societe_id: item.societe_id,
        });
      }

      this.recalculateTotals(list, form);
      form.selectedProduct = "";
    }
    ,
    async submitForm() {
      try {
        let user = decodeToken(localStorage.getItem("access_token"));
        this.form.societe_id = user.societe_id;
        this.form.cree_par = user.user_id;
        this.form.client_id = this.getClientID(this.form.nom_client);

        const response = await createCommand({
          date_creation: this.formatSQLDate(this.form.date_creation),
          statut: this.form.statut,
          mode_paiement: this.form.mode_paiement,
          conditions_paiement: this.form.conditions_paiement,
          date_livraison: this.formatSQLDate(this.form.date_livraison),
          client_id: this.form.client_id,
          montant_total: this.form.montant_TTC,
          montant_taxe: this.form.montant_TTC - this.form.montant_HT,

          notes: this.form.notes,
          cree_par: this.form.cree_par,
          societe_id: this.form.societe_id,
        });
        if (response !== null) {
          const commande_id = response.id;
          for (const product of selectedProducts) {
            await createCommandLine({
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: commande_id,
              item_type: product.item_type.toUpperCase(),
              item_id: product.item_id === null ? null : product.item_id,
              reduction: product.reduc ?? 0,
              nom_libre: product.item_id === null ? product.nom : null,
              societe_id: this.form.societe_id,
            });
          }

          commandeLinesCache.delete(commande_id);
          const response1 = await createDevis({
            statut: this.form.statut1,
            commande_id: commande_id,
            notes: this.form.notes,
            societe_id: this.form.societe_id,
          });
          this.$emit("devis-added", response1);
          const modalElement = document.getElementById("add-sales-new");
          const modal =
            Modal.getInstance(modalElement) || new Modal(modalElement);
          modal.hide();
        }
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    async submitForm1() {
      try {
        await updateCommand(this.form1.commande_id, {
          date_creation: this.formatSQLDate(this.form1.date_creation),
          statut: this.form1.statut,
          mode_paiement: this.form1.mode_paiement,
          conditions_paiement: this.form1.conditions_paiement,
          date_livraison: this.formatSQLDate(this.form1.date_livraison),
          client_id: this.form1.client_id,
          montant_total: this.form1.montant_TTC,
          montant_taxe: this.form1.montant_TTC - this.form1.montant_HT,
          notes: this.form1.notes,
          cree_par: this.form1.cree_par,
          societe_id: this.form1.societe_id,
        });
        for (const product of this.selectedProducts1) {
          if (product.id !== null) {
            console.log(product.nom);
            

            await updateCommandLine(product.id, {
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: this.form1.commande_id,
              item_type: product.item_type.toUpperCase(),
              item_id: product.item_id === null ? null : product.item_id,
              societe_id: this.form1.societe_id,
              reduction: product.reduc ?? 0,
              nom_libre: product.item_id === null ? product.nom : null,
            });
          } else {
            await createCommandLine({
              quantite: product.quantite,
              prix_unitaire: product.prix_unitaire,
              montant_HT: product.montant_HT,
              montant_TTC: product.montant_TTC,
              commande_id: this.form1.commande_id,
              item_type: product.item_type.toUpperCase(),
              item_id: product.item_id === null ? null : product.item_id,
              reduction: product.reduc ?? 0,
              nom_libre: product.item_id === null ? product.nom : null,
              societe_id: this.form1.societe_id,
            });
          }
        }
        for (const product of this.deletedProducts1) {
          if (product.id !== null) {
            await deleteCommandLine(product.id, this.form1.commande_id);
          }
        }

        commandeLinesCache.delete(this.form1.commande_id);
        const response1 = await updateDevis(this.form1.devis_id, {
          statut: this.form1.statut1,
          commande_id: this.form1.commande_id,
          notes: this.form1.notes,
          societe_id: this.form1.societe_id,
        });
        this.$emit("edit-added", response1);
        const modalElement = typeof document !== "undefined"
          ? document.getElementById("edit-sales-new")
          : null;
        if (modalElement) {
          const modal =
            Modal.getInstance(modalElement) || new Modal(modalElement);
          modal.hide();
        }
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    formatDateForInput(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      return date.toISOString().split("T")[0];
    },
    formatSQLDate(value) {
      try {
        const d = value instanceof Date ? value : new Date(value);
        if (isNaN(d)) return null;
        return d.toISOString().slice(0, 19).replace("T", " ");
      } catch (_) {
        return null;
      }
    },
    handleType(value) {
      this.selectedType = value;
    }
  },
  mounted() {
    this.getClientsData();
    this.getProductsData();
  },
  beforeUnmount() {
    if (activeCommandeLinesId && activeCommandeLinesFetch) {
      activeCommandeLinesFetch = null;
      activeCommandeLinesId = null;
    }
    Object.values(this.$refs)
      .filter((refEl) => refEl && typeof refEl.destroy === "function")
      .forEach((refEl) => {
        try {
          refEl.destroy();
        } catch (error) {
          console.error('Error loading cached commande lines:', error);
          return [];
        }
      });
  },
  watch: {
    data: {
      immediate: true,
      async handler(newData) {
        if (!newData) return;
        (this.form1.devis_id = newData.id),
          (this.form1.nom_client = this.getClientName(newData.client_id));
        this.form1.montant_HT = newData.montant_taxe;
        this.form1.montant_TTC = newData.montant_total;
        this.form1.mode_paiement = newData.mode_paiement;
        this.form1.client_id = newData.client_id;
        this.form1.notes = newData.notes;
        this.form1.societe_id = newData.societe_id;
        this.form1.numero_devis = newData.numero_devis;
        this.form1.statut1 = newData.statut;
        this.form1.delaiLivraision = "1 semaine (7 jours)";
        this.form1.commande_id = newData.commande_id;
        if (newData.commande) {
          this.form1.date_creation = new Date(newData.commande?.date_creation);
          this.form1.statut = newData.commande.statut;
          this.form1.conditions_paiement = newData.commande.conditions_paiement;
          this.form1.date_livraison = new Date(
            newData.commande?.date_livraison
          );
          this.form1.numero_commande = newData.commande.numero_commande;
          this.form1.cree_par = newData.commande.cree_par;
        } else {
          console.warn("commande is undefined in newData");
        }

        try {
          await this.loadCommandeLines(this.form1.commande_id);
        } catch (error) {
          console.warn('Failed to load commande lines:', error);
        }
      },
    },
    selectedTypeAdd(value) {
      if (!value) return;
      const type = value === "PRODUIT" ? "product" : "service";
      this.itemsList = this.productsIds
        .filter(p => p.item_type === type)
        .map(p => p.nom);
    },

    selectedTypeEdit(value) {
      if (!value) return;
      const type = value === "PRODUIT" ? "product" : "service";
      this.itemsList = this.productsIds
        .filter(p => p.item_type === type)
        .map(p => p.nom);
    },
  },
};
</script>